// SMB vs EU split values as a [SMB, EU] pair. Both come from their own rows in the data,
// they are read as is and are not derived from the Total row
export type TSmbEuValues = [number, number]

const diff = (a: number, b: number): number => {
  const isNoA = a === null || a === undefined
  const isNoB = b === null || b === undefined

  // Keep no data as no data instead of turning it into a zero
  if (isNoA && isNoB) {
    return null as unknown as number
  }

  return Number(a || 0) - Number(b || 0)
}

// Transactional has no own rows in the data, it is Total minus Contractual.
// The same subtraction is applied inside each fraction separately.
export const getSmbEuDiff = (
  [smbA, euA]: TSmbEuValues,
  [smbB, euB]: TSmbEuValues
): TSmbEuValues => [diff(smbA, smbB), diff(euA, euB)]
